import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { ZyInlineEnumNodeView } from './zyinlineenum-node-view';

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        zyInlineEnum: {
            insertZyInlineEnum: () => ReturnType;
        };
    }
}

export type ZyInlineEnumType = 'LaTex' | 'MathML';

export const ZyInlineEnumHeadless = Node.create({
    name: 'zyInlineEnum',

    content: '(blockMath | paragraph){1}', // The paragraph is needed to allow for the block math to be edited

    group: 'block',

    selectable: true,

    isolating: true,

    draggable: true,

    addAttributes() {
        return {
            id: {
                default: null,
                parseHTML: element => {
                    return element.getAttribute('id');
                },
                renderHTML: attributes => {
                    if (!attributes.id) {
                        return {};
                    }
                    return {
                        id: attributes.id,
                    };
                },
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'zyInlineEnum',
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ['zyInlineEnum', HTMLAttributes, 0];
    },

    addCommands() {
        return {
            insertZyInlineEnum:
                () =>
                ({ chain }) => {
                    return chain()
                        .clearNodeSelection()
                        .insertContent({
                            type: 'zyInlineEnum',
                            content: [
                                {
                                    type: 'blockMath',
                                    attrs: {
                                        latex: '\\int_a^b x^2 dx',
                                    },
                                },
                            ],
                        })
                        .run();
                },
        };
    },
});

export const ZyInlineEnum = ZyInlineEnumHeadless.extend({
    addNodeView() {
        return ReactNodeViewRenderer(ZyInlineEnumNodeView);
    },
});

export default ZyInlineEnum;
